<div class="content_modal" [ngClass]="showQuota ? '' : 'hideQuota'">
    <div class="asepticModalHead d-flex">
        <div class="w-100">
            <div class="align-items-center justify-content-between d-flex">
                <div class=" w-100 align-items-center d-flex justify-content-between observetabView p-0">
                    <div class="col d-flex section-title p-0 font18 observe-title">{{selectedward | translate | labelSanitizer}} / {{selecteddept | translate | labelSanitizer}}</div>
                    <span class="font13" id="time"></span>
                </div>
                <div class="endsessionDiv d-lg-flex col-auto">
                    <button class="justify-content-end align-items-center btn-cancel-bd endsession"
                    [disabled]="observationService.enableEdit"
                    (click)="endSession()">{{ translationKeys.Observation.EndObservationExit | translate }}</button>
                </div>
            </div>
        </div>
    </div>
    <div class="observeComponent flexDirectionColumn p-0">
        <div class="h-100 m-0 observations-content ">
            <div class="observeLeft mbp-0" [ngClass]="showQuota ? '' : 'hideQuota'">
                <div class="quotaDetail justify-content-between" *ngIf="showQuota">
                    <div class="d-flex progress-section">
                        <div class="progress-container align-items-center justify-content-between d-flex ">
                            <div class="progress observe-subtitle" >
                                <div class="progress-bar" role="progressbar" [ngStyle]="{'width.%': ((getQuota()/quotaDetails.totalQuotas)*100)}"></div>
                            </div>
                        </div>
                        <label class="daysLeft-container col-auto align-items-center p-0" *ngIf="showQuota">
                            <span class="section-title d-flex align-items-center">
                            <span class="pl-1 section-title colorBlue">{{getQuota()}}</span><span
                                class="usedQuotaSeperator">/</span>{{quotaDetails.totalQuotas}}
                            </span>
                        </label>
                    </div>
                    <div class="row col col-md-auto justify-content-end d-flex pr-0 section-title observe-subtitle" *ngIf="showQuota">                   
                        <ng-template [ngIf]="quotaDaysLeft != 0">
                            <span class="usedQuotaSeperator colorGray">{{quotaDaysLeft}} {{((quotaDaysLeft != 1)? translationKeys.Observation.DaysLeft : translationKeys.Observation.DayLeft )| translate}}</span>
                        </ng-template>
                    </div>
                </div>
                <div class="observeLeftHead observeWindow">
                    <div class="col-12 d-flex justify-content-start align-items-center">
                        <h1 class="section-title my-3">{{ translationKeys.Observation.History | translate}}</h1>
                    </div>
                </div>
                <div class="observation-container m-0">
                    <div class="col-12 p-0 pb-4 categoryUlTabContain" data-simplebar>
                        
                        <ul class="observationUlTabContain mbm-0">
                            
                            <li class="observation-li" *ngFor="let observation of observationService.observationsList;let i = index" (click)="viewObservation($event, observation)">
                                <hr class="historic-sep" *ngIf="i != 0">
                                <div class="observation-item"  [ngClass]="
                                                        { 'editionMode' : (observationService.editID) &&  observationService.editID == observation.observeObservationID,
                                                          'disabled': observationService.enableEdit && (observationService.editID != observation.observeObservationID) }"> 
                                    <p class="observation-time">{{getTime(observation)}}</p>
                                    <div class="d-flex justify-content-between">
                                        <div class="observation-labels d-grid justify-content-start">
                                            <ion-label class="observation-title">{{getCategoryName(observation.professsionalCategoryID) | translate}}</ion-label>
                                            <ion-label class="suboccupation-title" *ngIf="observation.professionalSubCategoryID">{{getSubCategoryName(observation.professionalSubCategoryID) | translate}}</ion-label>
                                        </div>
                                        <div class="observation-ctrls d-grid justify-content-end">
                                            <div *ngIf="observation.saved && !observation.completed" class="mb-2 d-flex justify-content-end align-items-center warning-icon">
                                                <img class="pr-1" src="assets/icons/icon-warning-outline.svg" />
                                                <span class="uncompleted-observation">{{ 'OBSERVATION.UNCOMPLETED' | translate }}</span>
                                            </div>
                                            <div *ngIf="!observation.saved" class="mb-2 d-flex justify-content-end align-items-center warning-icon">
                                                <img class="pr-1" src="assets/icons/icon-refresh.svg" />
                                                <span class="unsaved-observation">{{ 'OBSERVATION.UNSAVED' | translate }}</span>
                                            </div>
                                            <div class="d-flex justify-content-end">
                                                <button *ngIf="!observation.saved" class="btnObservation btn-bd-empty square editBtn" (click)="refreshObservation($event, observation)">
                                                    <mat-icon>send</mat-icon>
                                                </button>
                                                <button *ngIf="observation.saved && (!observationService.enableEdit || observationService.editID != observation.observeObservationID)" class="btnObservation btn-bd-empty square editBtn" (click)="editObservation($event, observation)"
                                                    [disabled]="observationService.enableEdit && (observationService.editID != observation.observeObservationID)">
                                                    <mat-icon>edit</mat-icon>
                                                </button>
                                                <button class="btnObservation btn-bd-empty square" (click)="confirmDeleteObservation($event, observation, confirmDeletionModal )">
                                                    <mat-icon outline>delete</mat-icon>
                                                </button>
                                            </div>
                                            
                                        </div>
                                    </div>          
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                
            </div>

            <div class=" d-flex observeRight IEp-0  pb-4" [ngClass]="{'active' : observeRightTab }" data-simplebar>
                
                <div *ngIf="showindication">
                    <lib-ph-bhp-observation-moments #moments [observeRightTab]="observeRightTab" [currentDate]="currentDate" [updatesession]="updatesession" [sessionActive]="sessionActive" [categories]="categories" [subcategories]="subcategories" 
                        [sessionName]="sessionName" [wardID]="wardID" [departmentID]="departmentID" [departmentTypeID]="departmentTypeID" [createdBy]="createdBy" (finishEdit)="finishEdit()" (newchildData)="confirmEvent($event)" (goBackEmitter)="cancelObservation(backmodal)"  
                        [handWashingEnabled]="handWashingEnabled" [showProfessionalSubcategory]="showProfessionalSubcategory" [showAseptictasks]="showAseptictasks" [observedCount]="showQuota ? observationService.observationsInQuota : observedQuotas" [quotaId]="(quotaDetails)?quotaDetails.quotaID:0" [iswebKessConnectionEstablished]="iswebKessConnectionEstablished"
                        [enableHandKissSurveillance]="enableHandKissSurveillance" [complianceInstitutionData]="complianceInstitutionData">
                    </lib-ph-bhp-observation-moments>
                </div>
            </div>
        </div>
    </div>
    <div class="w-100 observe-buttons" *ngIf="moments">
        <!-- need two buttons for translations, this not works with the translation pipe
        {{(observeService.enableEdit ? translationKeys.Authorization.Cancel : translationKeys.Observation.Next) | translate}}</button>
        -->
        <button class="btn-bd-empty cancelEdit" (click)="moments.cancelEdit()" *ngIf="observationService.enableView">{{translationKeys.SOPObservation.Back | translate}}</button>
        <button class="btn-bd-empty cancelEdit" (click)="moments.cancelEdit()" *ngIf="observationService.enableEdit">{{translationKeys.Authorization.Cancel | translate}}</button>
        <button class="saveBtn btn-bd" *ngIf="!observationService.enableEdit && !observationService.enableView" [disabled]="moments.nextIsDisabled()" (click)="moments.SubmitObservationSession('savesession')">{{translationKeys.Observation.Next | translate}}</button>
        <button class="saveBtn btn-bd ml-3" *ngIf="observationService.enableEdit && !observationService.enableView" [disabled]="moments.nextIsDisabled()" (click)="moments.SubmitObservationSession('updatesession')" >{{translationKeys.Button.Update | translate}}</button>
    </div>
</div>


<ng-template #confirmDeletionModal>
    <div class="mb-4 modal-header justify-content-between align-items-center">
        <h5 class="modal-title">{{ translationKeys.InstitutionManagement.Confirmation | translate }}</h5>
        <a class="cursor" data-dismiss="modal" (click)="modalRefPopUp.hide()"><img src="assets/ph-bhp-layout/svg/remove.svg"></a>
    </div>
    <div class="modal-body">
        <p> {{"OBSERVATION.CONFIRMATION.DELETE_OBSERVATION" | translate}} </p>
    </div>
    <div class="modal-footer">
        <div class="align-items-end d-flex">
            <button (click)="modalRefPopUp.hide(); observationIdToDelete = null" class="btn-cancel-bordered-bd separate-buttons">{{ 'INSTITUTION_MANAGEMENT.NO' | translate }}</button>
            <button (click)="modalRefPopUp.hide(); deleteObservation();" class="btn-bd-empty">{{ 'INSTITUTION_MANAGEMENT.YES' | translate }}</button>
        </div>
    </div>
</ng-template>

<ng-template #noObservationsmodal>
    <div class="mb-4 modal-header justify-content-between align-items-center">
        <h5 class="modal-title">{{ translationKeys.InstitutionManagement.Confirmation | translate }}</h5>
        <a class="cursor" data-dismiss="modal" (click)="modalRefPopUp.hide()"><img src="assets/ph-bhp-layout/svg/remove.svg"></a>
    </div>
    <div class="modal-body">
        <p> {{ translationKeys.Observation.NoObservationForSession | translate}} </p>
        <p> {{ translationKeys.Observation.ConfirmEndSession | translate }} </p>
    </div>
    <div class="modal-footer">
        <div class="align-items-end d-flex">
            <button (click)="modalRefPopUp.hide();" class="btn-cancel-bordered-bd separate-buttons">{{ translationKeys.Observation.ContinueObserving | translate }}</button>
            <button (click)="this.navigateToObservationProtocol();" class="btn-bd-empty">{{ translationKeys.Observation.EndObservationExit | translate }}</button>
        </div>
    </div>
</ng-template>

<ng-template #endsessionmodal>
    <div class="mb-4 modal-header justify-content-between align-items-center">
        <h5 class="modal-title">{{ translationKeys.InstitutionManagement.Confirmation | translate}}</h5>
        <a class="cursor" data-dismiss="modal" (click)="modalRefPopUp.hide()"><img src="assets/ph-bhp-layout/svg/remove.svg"></a>
    </div>
    <div class="modal-body">
        <p [innerHTML]="getEndSessionMessage()"></p>
    </div>
    <div class="modal-footer">
        <div class="align-items-end d-flex">
            <button (click)="modalRefPopUp.hide();" class="btn-cancel-bordered-bd separate-buttons continue">{{ translationKeys.Observation.ContinueObserving | translate }}</button>
            <button (click)="this.navigateToObservationProtocol();" class="btn-bd-empty">{{ translationKeys.Observation.EndObservationExit | translate }}</button>
        </div>
    </div>
</ng-template>
